






























































import mixins from 'vue-typed-mixins';
import { MultipleChoiceDataSetOptions } from '.';
import DataSetUtils, { DataSet } from '@/utils/DataSetUtils';

export default mixins().extend({
  props: {
    value: {
      type: Object as () => MultipleChoiceDataSetOptions,
    },
  },

  computed: {
    datasetOptions(): any {
      return this.datasets?.map((dataset) => ({
        text: dataset.name,
        value: { key: dataset.key },
      }));
    },

    typeOptions(): any {
      return [
        {
          text: this.$tc(
            'model.question.options.multiple_choice_data_set.type.enforce'
          ),
          value: 'enforce',
        },
        {
          text: this.$tc(
            'model.question.options.multiple_choice_data_set.type.guideline'
          ),
          value: 'guideline',
        },
      ];
    },

    multipleOptions(): any {
      return [
        {
          text: this.$tc(
            'model.question.options.multiple_choice_data_set.multiple.false'
          ),
          value: false,
        },
        {
          text: this.$tc(
            'model.question.options.multiple_choice_data_set.multiple.true'
          ),
          value: true,
        },
      ];
    },
  },

  data(): {
    datasets?: DataSet[];
  } {
    return {
      datasets: undefined,
    };
  },

  mounted() {
    this.loadDataSets(); // async load
    // set  values to defaults
    this.$emit('input', {
      dataset: this.value.dataset || undefined,
      type: this.value.type || 'enforce',
      multiple: this.value.multiple !== undefined ? this.value.multiple : true,
      label: this.value.label || this.$languageobj(),
    });
  },

  methods: {
    async loadDataSets() {
      try {
        this.$alert.hide('loadDataSets');
        this.datasets = await DataSetUtils.api.dataset.list();
      } catch (error) {
        this.$alert.show('loadDataSets', {
          type: 'error',
          messages: this.$handleAPIError(error),
        });
      }
    },
  },
});
